<template>
  <el-select v-model="lang" class="loginBtn" @change="changeLangEvent">
    <el-option
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value"
    >
    </el-option>
  </el-select>
</template>
<script>
export default {
  name: "language",
  data() {
    return {
      options: [
        {
          value: "zh-CN",
          label: "中文",
        },
        {
          value: "en",
          label: "English",
        },
        {
          value: "zh-TW",
          label: "繁體",
        },
        {
          value: "vi-VN",
          label: "Tiếng Việt",
        },
      ],
      lang: "",
    };
  },
  mounted() {
    if (localStorage.getItem("locale")) {
      this.lang = localStorage.getItem("locale");
      this.$i18n.locale = this.lang;
    } else {
      this.lang = "en";
      this.$i18n.locale = this.lang;
      localStorage.setItem("locale","en");
    }
  },
  methods: {
    changeLangEvent() {
      this.$i18n.locale = this.lang;
      localStorage.setItem("locale", this.lang);
      window.location.reload();
    },
  },
};
</script>
<style lang="scss">
.loginBtn {
  margin-top: 20px;
  .el-input__inner {
    background-color: #333333;
    font-size: 16px;
    width: 120px;
    color: #f2f2f2;
    border: none;
  }
}
</style>


// WEBPACK FOOTER //
// src/page/language.vue